export const queryBuild = (query: Record<string, string | number>) => {
  const queryArray = Object.entries(query).reduce((previousValue, currentValue) => {
    if (currentValue[1]) {
      const queryString = currentValue.join(`=`);
      return [...previousValue, queryString];
    }

    return previousValue;
  }, [] as string[]);

  return queryArray.length > 0 ? `?${queryArray.join(`&`)}` : ``;
};
